/**
 * Works out which jewellery category a product belongs to.
 *
 * Imported catalogues are inconsistent: the product type may be "Womens Ring", "Couple Ring", "Stud Earrings",
 * "Hoop Earring" — or empty — and tags are noisy (campaign names, colours…). So we read three sources in order of
 * reliability: product type, then title, then tags. Within each source the rules are checked most-specific first,
 * so "Chain Earrings" is an earring and "Pendant Necklace" a necklace. Word boundaries keep "ring" from matching
 * "earring".
 */

// key = the value used in /shop?type=…, label = what shoppers see
export const CATEGORY_RULES = [
  { key: 'Earring', label: 'Earrings', re: /\bear-?rings?\b|\bstuds?\b|\bhoops?\b|\bjhumk|\bdanglers?\b|\bhuggies?\b|\bear ?cuffs?\b/ },
  { key: 'Nosepin', label: 'Nose pins', re: /\bnose ?pins?\b|\bnose ?rings?\b|\bnath\b/ },
  { key: 'Anklet', label: 'Anklets', re: /\banklets?\b|\bpayal\b/ },
  { key: 'Mangalsutra', label: 'Mangalsutra', re: /\bmangalsutra/ },
  { key: 'Bracelet', label: 'Bracelets', re: /\bbracelets?\b/ },
  { key: 'Bangle', label: 'Bangles', re: /\bbangles?\b|\bkadas?\b/ },
  { key: 'Set', label: 'Sets', re: /\bjewell?ery sets?\b|\bsets?\b/ },
  { key: 'Necklace', label: 'Necklaces', re: /\bnecklaces?\b|\bchokers?\b/ },
  { key: 'Pendant', label: 'Pendants', re: /\bpendants?\b|\blockets?\b/ },
  { key: 'Chain', label: 'Chains', re: /\bchains?\b/ },
  { key: 'Ring', label: 'Rings', re: /\brings?\b|\bsolitaire\b|\bband\b/ },
];

const tagText = (tags) => (Array.isArray(tags) ? tags.join(' , ') : String(tags || ''));

const firstMatch = (text) => {
  const t = String(text || '').toLowerCase();
  if (!t.trim()) return null;
  const rule = CATEGORY_RULES.find((r) => r.re.test(t));
  return rule ? rule.key : null;
};

export const categorize = (product) => {
  if (!product) return null;
  return firstMatch(product.productType || product.type)
    || firstMatch(product.title)
    || firstMatch(tagText(product.tags))
    || null;
};

export const categoryLabel = (key) => CATEGORY_RULES.find((r) => r.key === key)?.label || key || '';
